import React, { useContext, useState } from "react";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import Scrollspy from "react-scrollspy";
import AnchorScroll from "react-anchor-link-smooth-scroll";
import Link from "next/link";
import styles from "./style.module.css";

import { DrawerContext } from "../DrawerContext";

const AnchorLink = (props) => {
  const router = useRouter();

  console.log("router", router.pathname);
  if (router.pathname === props.basePath) {
    return (
      <AnchorScroll {...props} href={props?.scrollPath}>
        {props.children}
      </AnchorScroll>
    );
  } else {
    return (
      <Link {...props}>
        <a>{props.children}</a>
      </Link>
    );
  }
};

const ScrollSpyMenu = ({
  main,
  className,
  menuItems,
  drawerClose,
  ...props
}) => {
  const { dispatch } = useContext(DrawerContext);
  // empty array for scrollspy items
  const scrollItems = [];

  // convert menu path to scrollspy items
  menuItems.forEach((item) => {
    if (item.path) {
      scrollItems.push(item.path.slice(1));
    }
  });

  // Add all classs to an array
  const addAllClasses = ["scrollspy__menu"];

  // className prop checking
  if (className) {
    addAllClasses.push(className);
  }

  // Close drawer when click on menu item
  const toggleDrawer = (onClick) => () => {
    if (onClick) {
      onClick();
    }
    dispatch({
      type: "TOGGLE",
    });
  };

  function DropdownItem({ item, index }) {
    const [open, setOpen] = useState(false);
    return (
      <li
        key={`menu-item-${index}`}
        onMouseOver={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        className={`${open ? styles.open : ""}`}
      >
        <div>{item.label}</div>
        {open && (
          <div
            className={styles.dropdownMenu}
            aria-labelledby="dropdownMenuButton"
          >
            {item.dropdown.map((item, index) => (
              <a
                key={`dropdown-menu-item-${index}`}
                className={styles.dropdownItem}
                href={item.path}
              >
                {item.label}
              </a>
            ))}
          </div>
        )}
      </li>
    );
  }

  const renderItem = (menu, index) => {
    if (menu?.dropdown) {
      return <DropdownItem item={menu} index={index} />;
    }

    if (menu.staticLink) {
      return (
        <li key={`menu-item-${index}`}>
          <a href={menu.path}>{menu.label}</a>
        </li>
      );
    }

    if (!menu.path) {
      return (
        <li key={`menu-item-${index}`}>
          <div onClick={menu.onClick}>{menu.label}</div>
        </li>
      );
    }

    return (
      <li key={`menu-item-${index}`}>
        {menu.staticLink ? (
          <a href={menu.path}>{menu.label}</a>
        ) : (
          <>
            {drawerClose ? (
              <AnchorLink
                href={menu.path}
                offset={menu.offset}
                onClick={toggleDrawer(menu?.onClick)}
                basePath={menu?.basePath}
                scrollPath={menu?.scrollPath}
              >
                {menu.label}
              </AnchorLink>
            ) : (
              <AnchorLink
                href={menu.path}
                offset={menu.offset}
                basePath={menu?.basePath}
                scrollPath={menu?.scrollPath}
              >
                {menu.label}
              </AnchorLink>
            )}
          </>
        )}
      </li>
    );
  };

  return (
    <Scrollspy
      items={scrollItems}
      className={addAllClasses.join(" ")}
      drawerClose={drawerClose}
      {...props}
    >
      {menuItems.map((menu, index) => (
        <React.Fragment key={`menu-item-${index}`}>
          {renderItem(menu, index)}
        </React.Fragment>
      ))}
    </Scrollspy>
  );
};

ScrollSpyMenu.propTypes = {
  /** className of the ScrollSpyMenu. */
  className: PropTypes.string,

  /** menuItems is an array of object prop which contain your menu
   * data.
   */
  menuItems: PropTypes.array.isRequired,

  /** Class name that apply to the navigation element paired with the content element in viewport. */
  currentClassName: PropTypes.string,

  /** Class name that apply to the navigation elements that have been scrolled past [optional]. */
  scrolledPastClassName: PropTypes.string,

  /** HTML tag for Scrollspy component if you want to use other than <ul/> [optional]. */
  componentTag: PropTypes.string,

  /** Style attribute to be passed to the generated <ul/> element [optional]. */
  style: PropTypes.object,

  /** Offset value that adjusts to determine the elements are in the viewport [optional]. */
  offset: PropTypes.number,

  /** Name of the element of scrollable container that can be used with querySelector [optional]. */
  rootEl: PropTypes.string,

  /**
   * Function to be executed when the active item has been updated [optional].
   */
  onUpdate: PropTypes.func,
};

ScrollSpyMenu.defaultProps = {
  componentTag: "ul",
  currentClassName: "is-current",
};

export default ScrollSpyMenu;
